import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MOBILE_APP_SMART_BANNER_CONFIG = createFcmDetails('mobile_app_smart_banner_config', {
	owner: 'Mobile Squad',
	context: 'All Site Pages (petition starters)',
	description:
		'This FC controls the inclusion of the Apple iOS Smart Banner META tag on all site pages, for users who are petition starters.',
	template: {
		appId: '1144132710',
		enabled: false,
	},
	import: false,
});
